export default class ScoreCalculator {

  constructor () {
    this.DEFAULT_SYMBOL_SCORE = 1;
    this.scores = {};
    this.bonuses = {};

    this.initScores()
  }

  initScores () {
    this.scores['c'] = 4;
    this.scores['b'] = 7;
    this.scores['d'] = 2;
    this.scores['g'] = 5;
    this.scores['h'] = 2;
    this.scores['l'] = 2;
    this.scores['m'] = 4;
    this.scores['p'] = 4;
    this.scores['r'] = 2;
    this.scores['s'] = 2;
    this.scores['t'] = 4;
    this.scores['u'] = 4
  }

  getScoreForWordSimple (word) {
    var score = 0;

    for (var i = 0; i < word.length; i++) {
      var symbol = word.charAt(i);
      score += this.getScoreForSymbol(symbol)
    }

    return score
  }

  getScoreForSymbol (symbol) {
    if (this.scores[symbol]) return this.scores[symbol];
    else return this.DEFAULT_SYMBOL_SCORE
  }

  getScoreForWord (word) {
    var score = 0;
    var areSymbolsIdentical = true;
    var prevSymbol = null;

    for (var i = 0; i < word.length; i++) {
      var symbol = word.charAt(i);
      score += this.getScoreForSymbol(symbol);

      if (prevSymbol !== null && prevSymbol !== symbol) {
        areSymbolsIdentical = false
      }
      prevSymbol = symbol
    }

    if (!areSymbolsIdentical) {
      score *= word.length
    }

    score *= 2;

    return score
  }
}
